var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPromptRecommendedFeaturesSocial = function SvgIconPromptRecommendedFeaturesSocial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#4B4F58",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "M10.502 7.68 8.002 10 5.505 7.68a1.6 1.6 0 0 1-.381-.53 1.48 1.48 0 0 1 .035-1.252c.098-.195.238-.37.41-.511.174-.142.376-.25.595-.314a1.77 1.77 0 0 1 1.329.133c.2.106.374.251.51.424.139-.172.313-.315.512-.42A1.772 1.772 0 0 1 9.84 5.08c.219.065.42.171.593.313.172.142.312.315.41.51a1.48 1.48 0 0 1 .037 1.248c-.085.2-.214.38-.377.53m1.698 4.283h-1.942a.53.53 0 0 0-.258.068.6.6 0 0 0-.207.19l-1.328 1.518a.6.6 0 0 1-.209.19.54.54 0 0 1-.52 0 .6.6 0 0 1-.208-.19l-1.321-1.517a.6.6 0 0 0-.207-.19.53.53 0 0 0-.259-.069H3.8c-.997 0-1.8-.922-1.8-2.069V4.07C2 2.923 2.803 2 3.8 2h8.4c.998 0 1.8.923 1.8 2.069v5.827c0 1.146-.802 2.07-1.8 2.07"
  })));
};
export default SvgIconPromptRecommendedFeaturesSocial;